import { render, staticRenderFns } from "./EOY2025Page.vue?vue&type=template&id=8d6f7c1a&scoped=true"
import script from "./EOY2025Page.vue?vue&type=script&lang=js"
export * from "./EOY2025Page.vue?vue&type=script&lang=js"
import style0 from "./EOY2025Page.vue?vue&type=style&index=0&id=8d6f7c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6f7c1a",
  null
  
)

export default component.exports